/**
 * Location Data - Countries, States/Provinces, and Cities
 * Comprehensive data for outlet location selection
 */

export const countries = [
  { code: 'IN', name: 'India', timezone: 'Asia/Kolkata' },
  { code: 'US', name: 'United States', timezone: 'America/New_York' },
  { code: 'GB', name: 'United Kingdom', timezone: 'Europe/London' },
  { code: 'AE', name: 'United Arab Emirates', timezone: 'Asia/Dubai' },
  { code: 'SG', name: 'Singapore', timezone: 'Asia/Singapore' },
  { code: 'AU', name: 'Australia', timezone: 'Australia/Sydney' },
  { code: 'CA', name: 'Canada', timezone: 'America/Toronto' },
  { code: 'DE', name: 'Germany', timezone: 'Europe/Berlin' },
  { code: 'FR', name: 'France', timezone: 'Europe/Paris' },
  { code: 'JP', name: 'Japan', timezone: 'Asia/Tokyo' },
  { code: 'CN', name: 'China', timezone: 'Asia/Shanghai' },
  { code: 'BR', name: 'Brazil', timezone: 'America/Sao_Paulo' },
  { code: 'MX', name: 'Mexico', timezone: 'America/Mexico_City' },
  { code: 'ZA', name: 'South Africa', timezone: 'Africa/Johannesburg' },
  { code: 'NZ', name: 'New Zealand', timezone: 'Pacific/Auckland' },
  { code: 'IT', name: 'Italy', timezone: 'Europe/Rome' },
  { code: 'ES', name: 'Spain', timezone: 'Europe/Madrid' },
  { code: 'NL', name: 'Netherlands', timezone: 'Europe/Amsterdam' },
  { code: 'SE', name: 'Sweden', timezone: 'Europe/Stockholm' },
  { code: 'CH', name: 'Switzerland', timezone: 'Europe/Zurich' },
  { code: 'MY', name: 'Malaysia', timezone: 'Asia/Kuala_Lumpur' },
  { code: 'TH', name: 'Thailand', timezone: 'Asia/Bangkok' },
  { code: 'ID', name: 'Indonesia', timezone: 'Asia/Jakarta' },
  { code: 'PH', name: 'Philippines', timezone: 'Asia/Manila' },
  { code: 'VN', name: 'Vietnam', timezone: 'Asia/Ho_Chi_Minh' },
  { code: 'KR', name: 'South Korea', timezone: 'Asia/Seoul' },
  { code: 'SA', name: 'Saudi Arabia', timezone: 'Asia/Riyadh' },
  { code: 'QA', name: 'Qatar', timezone: 'Asia/Qatar' },
  { code: 'KW', name: 'Kuwait', timezone: 'Asia/Kuwait' },
  { code: 'BH', name: 'Bahrain', timezone: 'Asia/Bahrain' },
  { code: 'OM', name: 'Oman', timezone: 'Asia/Muscat' },
  { code: 'EG', name: 'Egypt', timezone: 'Africa/Cairo' },
  { code: 'NG', name: 'Nigeria', timezone: 'Africa/Lagos' },
  { code: 'KE', name: 'Kenya', timezone: 'Africa/Nairobi' },
  { code: 'PK', name: 'Pakistan', timezone: 'Asia/Karachi' },
  { code: 'BD', name: 'Bangladesh', timezone: 'Asia/Dhaka' },
  { code: 'LK', name: 'Sri Lanka', timezone: 'Asia/Colombo' },
  { code: 'NP', name: 'Nepal', timezone: 'Asia/Kathmandu' },
].sort((a, b) => a.name.localeCompare(b.name));

export const states = {
  // India - All States and Union Territories
  IN: [
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'CT', name: 'Chhattisgarh' },
    { code: 'DN', name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { code: 'DL', name: 'Delhi' },
    { code: 'GA', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ML', name: 'Meghalaya' },
    { code: 'MZ', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OR', name: 'Odisha' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TG', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UT', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' },
  ],
  // United States
  US: [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
    { code: 'DC', name: 'District of Columbia' },
  ],
  // United Kingdom
  GB: [
    { code: 'ENG', name: 'England' },
    { code: 'SCT', name: 'Scotland' },
    { code: 'WLS', name: 'Wales' },
    { code: 'NIR', name: 'Northern Ireland' },
  ],
  // UAE
  AE: [
    { code: 'AZ', name: 'Abu Dhabi' },
    { code: 'DU', name: 'Dubai' },
    { code: 'SH', name: 'Sharjah' },
    { code: 'AJ', name: 'Ajman' },
    { code: 'UQ', name: 'Umm Al Quwain' },
    { code: 'RK', name: 'Ras Al Khaimah' },
    { code: 'FU', name: 'Fujairah' },
  ],
  // Singapore (single state)
  SG: [
    { code: 'SG', name: 'Singapore' },
  ],
  // Australia
  AU: [
    { code: 'NSW', name: 'New South Wales' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'WA', name: 'Western Australia' },
    { code: 'SA', name: 'South Australia' },
    { code: 'TAS', name: 'Tasmania' },
    { code: 'ACT', name: 'Australian Capital Territory' },
    { code: 'NT', name: 'Northern Territory' },
  ],
  // Canada
  CA: [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'YT', name: 'Yukon' },
  ],
};

export const cities = {
  // ==================== INDIA - Detailed Cities ====================
  
  // Andhra Pradesh
  'IN-AP': [
    'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Rajahmundry',
    'Kakinada', 'Tirupati', 'Kadapa', 'Anantapur', 'Eluru', 'Ongole', 'Vizianagaram',
    'Machilipatnam', 'Tenali', 'Proddatur', 'Chittoor', 'Hindupur', 'Bhimavaram',
    'Madanapalle', 'Guntakal', 'Dharmavaram', 'Gudivada', 'Srikakulam', 'Nandyal',
    'Tadipatri', 'Mangalagiri', 'Chilakaluripet', 'Tadepalligudem', 'Amaravati',
  ],
  
  // Arunachal Pradesh
  'IN-AR': [
    'Itanagar', 'Naharlagun', 'Pasighat', 'Namsai', 'Tezu', 'Ziro', 'Bomdila',
    'Along', 'Khonsa', 'Anini', 'Seppa', 'Tawang', 'Roing', 'Changlang', 'Daporijo',
  ],
  
  // Assam
  'IN-AS': [
    'Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tinsukia', 'Tezpur',
    'Bongaigaon', 'Dhubri', 'Diphu', 'North Lakhimpur', 'Karimganj', 'Sivasagar',
    'Goalpara', 'Barpeta', 'Mangaldoi', 'Haflong', 'Nalbari', 'Morigaon', 'Golaghat',
  ],
  
  // Bihar
  'IN-BR': [
    'Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga', 'Bihar Sharif',
    'Arrah', 'Begusarai', 'Katihar', 'Munger', 'Chhapra', 'Sasaram', 'Hajipur',
    'Dehri', 'Siwan', 'Motihari', 'Nawada', 'Bagaha', 'Buxar', 'Kishanganj',
    'Sitamarhi', 'Jamalpur', 'Jehanabad', 'Aurangabad', 'Samastipur', 'Bettiah',
  ],
  
  // Chhattisgarh
  'IN-CT': [
    'Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg', 'Rajnandgaon', 'Raigarh',
    'Jagdalpur', 'Ambikapur', 'Chirmiri', 'Dhamtari', 'Mahasamund', 'Kanker',
    'Kawardha', 'Kondagaon', 'Mungeli', 'Narayanpur', 'Bemetara', 'Balod', 'Janjgir',
  ],
  
  // Delhi
  'IN-DL': [
    'New Delhi', 'North Delhi', 'South Delhi', 'East Delhi', 'West Delhi',
    'Central Delhi', 'North East Delhi', 'North West Delhi', 'South East Delhi',
    'South West Delhi', 'Shahdara', 'Dwarka', 'Rohini', 'Pitampura', 'Karol Bagh',
    'Connaught Place', 'Lajpat Nagar', 'Saket', 'Vasant Kunj', 'Janakpuri',
    'Nehru Place', 'Greater Kailash', 'Defence Colony', 'Hauz Khas', 'Malviya Nagar',
  ],
  
  // Goa
  'IN-GA': [
    'Panaji', 'Vasco da Gama', 'Margao', 'Mapusa', 'Ponda', 'Bicholim', 'Curchorem',
    'Sanquelim', 'Cuncolim', 'Valpoi', 'Cortalim', 'Canacona', 'Quepem', 'Sanguem',
    'Pernem', 'Calangute', 'Candolim', 'Anjuna', 'Baga', 'Colva', 'Benaulim', 'Arambol',
  ],
  
  // Gujarat
  'IN-GJ': [
    'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Junagadh',
    'Gandhinagar', 'Anand', 'Nadiad', 'Morbi', 'Mehsana', 'Bharuch', 'Vapi',
    'Navsari', 'Veraval', 'Porbandar', 'Godhra', 'Bhuj', 'Palanpur', 'Valsad',
    'Patan', 'Botad', 'Dahod', 'Amreli', 'Surendranagar', 'Gandhidham', 'GIFT City',
  ],
  
  // Haryana
  'IN-HR': [
    'Faridabad', 'Gurgaon', 'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar',
    'Karnal', 'Sonipat', 'Panchkula', 'Bhiwani', 'Sirsa', 'Bahadurgarh', 'Jind',
    'Thanesar', 'Kaithal', 'Rewari', 'Palwal', 'Hansi', 'Narnaul', 'Fatehabad',
    'Manesar', 'Dharuhera', 'Sohna', 'Hodal', 'Tohana', 'Ratia', 'Narwana',
  ],
  
  // Himachal Pradesh
  'IN-HP': [
    'Shimla', 'Mandi', 'Solan', 'Nahan', 'Bilaspur', 'Chamba', 'Dharamshala',
    'Kullu', 'Hamirpur', 'Una', 'Palampur', 'Baddi', 'Sundernagar', 'Paonta Sahib',
    'Manali', 'Kangra', 'Dalhousie', 'Kasauli', 'Kufri', 'Narkanda', 'Keylong',
  ],
  
  // Jharkhand
  'IN-JH': [
    'Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro Steel City', 'Deoghar', 'Hazaribagh',
    'Giridih', 'Ramgarh', 'Medininagar', 'Phusro', 'Chaibasa', 'Dumka', 'Chatra',
    'Gumla', 'Lohardaga', 'Koderma', 'Godda', 'Pakur', 'Sahebganj', 'Jamtara',
  ],
  
  // Karnataka
  'IN-KA': [
    'Bengaluru', 'Mysuru', 'Mangaluru', 'Hubballi', 'Belagavi', 'Kalaburagi',
    'Davanagere', 'Ballari', 'Vijayapura', 'Shivamogga', 'Tumakuru', 'Raichur',
    'Bidar', 'Hospet', 'Hassan', 'Udupi', 'Chitradurga', 'Bagalkot', 'Gadag',
    'Mandya', 'Haveri', 'Chikkamagaluru', 'Kolar', 'Ramanagara', 'Yadgir',
    'Dharwad', 'Karwar', 'Chamarajanagar', 'Madikeri', 'Koppal', 'Electronic City',
    'Whitefield', 'Koramangala', 'Indiranagar', 'HSR Layout', 'Jayanagar', 'Marathahalli',
  ],
  
  // Kerala
  'IN-KL': [
    'Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Kollam', 'Thrissur', 'Alappuzha',
    'Palakkad', 'Kannur', 'Kottayam', 'Malappuram', 'Kasaragod', 'Pathanamthitta',
    'Idukki', 'Wayanad', 'Ernakulam', 'Munnar', 'Guruvayur', 'Vadakara', 'Ponnani',
    'Manjeri', 'Kanhangad', 'Thalassery', 'Attingal', 'Kayamkulam', 'Changanassery',
    'Fort Kochi', 'Thekkady', 'Kumarakom', 'Varkala', 'Kovalam', 'Bekal',
  ],
  
  // Madhya Pradesh
  'IN-MP': [
    'Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas', 'Satna',
    'Ratlam', 'Rewa', 'Katni', 'Singrauli', 'Burhanpur', 'Khandwa', 'Bhind',
    'Chhindwara', 'Guna', 'Shivpuri', 'Vidisha', 'Damoh', 'Mandsaur', 'Khargone',
    'Neemuch', 'Pithampur', 'Hoshangabad', 'Itarsi', 'Sehore', 'Betul', 'Seoni',
  ],
  
  // Maharashtra
  'IN-MH': [
    'Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Solapur',
    'Kalyan-Dombivli', 'Vasai-Virar', 'Bhiwandi', 'Amravati', 'Nanded', 'Kolhapur',
    'Sangli', 'Malegaon', 'Jalgaon', 'Akola', 'Latur', 'Dhule', 'Ahmednagar',
    'Chandrapur', 'Parbhani', 'Ichalkaranji', 'Jalna', 'Ambernath', 'Bhusawal',
    'Panvel', 'Badlapur', 'Beed', 'Gondia', 'Satara', 'Barshi', 'Yavatmal',
    'Achalpur', 'Osmanabad', 'Nandurbar', 'Wardha', 'Udgir', 'Hinganghat',
    'Navi Mumbai', 'Lonavala', 'Alibaug', 'Matheran', 'Mahabaleshwar', 'Shirdi',
    'Andheri', 'Bandra', 'Powai', 'Worli', 'Lower Parel', 'BKC', 'Goregaon',
  ],
  
  // Manipur
  'IN-MN': [
    'Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Ukhrul', 'Senapati',
    'Tamenglong', 'Chandel', 'Kakching', 'Jiribam', 'Kangpokpi', 'Tengnoupal',
    'Moirang', 'Nambol', 'Moreh', 'Lilong',
  ],
  
  // Meghalaya
  'IN-ML': [
    'Shillong', 'Tura', 'Nongstoin', 'Jowai', 'Baghmara', 'Williamnagar', 'Resubelpara',
    'Mairang', 'Nongpoh', 'Cherrapunji', 'Mawlynnong', 'Dawki', 'Laitlum',
  ],
  
  // Mizoram
  'IN-MZ': [
    'Aizawl', 'Lunglei', 'Champhai', 'Serchhip', 'Kolasib', 'Lawngtlai', 'Mamit',
    'Saiha', 'Saitual', 'Hnahthial', 'Khawzawl',
  ],
  
  // Nagaland
  'IN-NL': [
    'Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha', 'Zunheboto', 'Mon',
    'Phek', 'Kiphire', 'Longleng', 'Peren', 'Chumukedima',
  ],
  
  // Odisha
  'IN-OR': [
    'Bhubaneswar', 'Cuttack', 'Rourkela', 'Brahmapur', 'Sambalpur', 'Puri',
    'Balasore', 'Baripada', 'Bhadrak', 'Jharsuguda', 'Angul', 'Bargarh', 'Paradip',
    'Kendrapara', 'Jeypore', 'Dhenkanal', 'Konark', 'Rayagada', 'Koraput', 'Jajpur',
  ],
  
  // Punjab
  'IN-PB': [
    'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali', 'Pathankot',
    'Hoshiarpur', 'Batala', 'Moga', 'Abohar', 'Malerkotla', 'Khanna', 'Phagwara',
    'Muktsar', 'Barnala', 'Rajpura', 'Firozpur', 'Kapurthala', 'Faridkot', 'Sangrur',
    'Fazilka', 'Gurdaspur', 'Zirakpur', 'Kharar', 'Dera Bassi', 'Nabha', 'Mansa',
  ],
  
  // Rajasthan
  'IN-RJ': [
    'Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara',
    'Alwar', 'Bharatpur', 'Sikar', 'Pali', 'Sri Ganganagar', 'Tonk', 'Kishangarh',
    'Beawar', 'Hanumangarh', 'Dhaulpur', 'Gangapur City', 'Sawai Madhopur',
    'Churu', 'Jhunjhunu', 'Bundi', 'Chittorgarh', 'Nagaur', 'Barmer', 'Mount Abu',
    'Pushkar', 'Jaisalmer', 'Neemrana', 'Manesar', 'Bhiwadi',
  ],
  
  // Sikkim
  'IN-SK': [
    'Gangtok', 'Namchi', 'Gyalshing', 'Mangan', 'Rangpo', 'Singtam', 'Jorethang',
    'Nayabazar', 'Ravangla', 'Pelling', 'Lachung', 'Lachen', 'Yuksom',
  ],
  
  // Tamil Nadu
  'IN-TN': [
    'Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli',
    'Tiruppur', 'Erode', 'Vellore', 'Thoothukudi', 'Dindigul', 'Thanjavur',
    'Nagercoil', 'Kancheepuram', 'Kumbakonam', 'Rajapalayam', 'Cuddalore',
    'Karur', 'Sivakasi', 'Namakkal', 'Tiruvannamalai', 'Pollachi', 'Pudukkottai',
    'Ambur', 'Nagapattinam', 'Ooty', 'Kodaikanal', 'Mahabalipuram', 'Rameswaram',
    'Kanyakumari', 'Anna Nagar', 'T Nagar', 'Adyar', 'Velachery', 'OMR', 'Tambaram',
  ],
  
  // Telangana
  'IN-TG': [
    'Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam', 'Ramagundam',
    'Mahbubnagar', 'Nalgonda', 'Adilabad', 'Siddipet', 'Miryalaguda', 'Mancherial',
    'Jagtial', 'Suryapet', 'Nirmal', 'Kothagudem', 'Bodhan', 'Sangareddy',
    'Secunderabad', 'HITEC City', 'Gachibowli', 'Madhapur', 'Kondapur', 'Banjara Hills',
    'Jubilee Hills', 'Kukatpally', 'Miyapur', 'Begumpet', 'Shamshabad',
  ],
  
  // Tripura
  'IN-TR': [
    'Agartala', 'Dharmanagar', 'Udaipur', 'Kailasahar', 'Belonia', 'Khowai',
    'Ambassa', 'Sabroom', 'Sonamura', 'Kamalpur', 'Melaghar', 'Amarpur',
  ],
  
  // Uttar Pradesh
  'IN-UP': [
    'Lucknow', 'Kanpur', 'Ghaziabad', 'Agra', 'Varanasi', 'Meerut', 'Prayagraj',
    'Bareilly', 'Aligarh', 'Moradabad', 'Saharanpur', 'Gorakhpur', 'Noida',
    'Greater Noida', 'Firozabad', 'Jhansi', 'Muzaffarnagar', 'Mathura', 'Rampur',
    'Shahjahanpur', 'Farrukhabad', 'Mau', 'Hapur', 'Etawah', 'Mirzapur', 'Bulandshahr',
    'Sambhal', 'Amroha', 'Hardoi', 'Fatehpur', 'Raebareli', 'Orai', 'Sitapur',
    'Bahraich', 'Modinagar', 'Unnao', 'Lakhimpur', 'Hathras', 'Banda', 'Pilibhit',
    'Sultanpur', 'Ayodhya', 'Vrindavan', 'Kushinagar', 'Sarnath',
  ],
  
  // Uttarakhand
  'IN-UT': [
    'Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur', 'Kashipur',
    'Rishikesh', 'Kotdwar', 'Srinagar', 'Pithoragarh', 'Ramnagar', 'Mussoorie',
    'Nainital', 'Almora', 'Tehri', 'Pauri', 'Chamoli', 'Uttarkashi', 'Champawat',
    'Bageshwar', 'Kedarnath', 'Badrinath', 'Gangotri', 'Yamunotri', 'Jim Corbett',
  ],
  
  // West Bengal
  'IN-WB': [
    'Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Bardhaman', 'Malda',
    'Baharampur', 'Habra', 'Kharagpur', 'Shantiniketan', 'Darjeeling', 'Jalpaiguri',
    'Balurghat', 'Basirhat', 'Bankura', 'Krishnanagar', 'Cooch Behar', 'Haldia',
    'Medinipur', 'Raiganj', 'Alipurduar', 'Purulia', 'Ranaghat', 'Santipur',
    'Kalimpong', 'Digha', 'Sundarbans', 'Salt Lake', 'New Town', 'Rajarhat',
  ],
  
  // Chandigarh
  'IN-CH': [
    'Chandigarh', 'Sector 17', 'Sector 22', 'Sector 35', 'Industrial Area',
  ],
  
  // Puducherry
  'IN-PY': [
    'Puducherry', 'Karaikal', 'Mahe', 'Yanam', 'Auroville', 'White Town',
  ],
  
  // Goa (additional)
  'IN-GA': [
    'Panaji', 'Vasco da Gama', 'Margao', 'Mapusa', 'Ponda', 'Bicholim',
    'Calangute', 'Candolim', 'Anjuna', 'Baga', 'Colva', 'Benaulim', 'Arambol',
    'Morjim', 'Vagator', 'Palolem', 'Agonda', 'Dudhsagar', 'Old Goa', 'Dona Paula',
  ],
  
  // Jammu and Kashmir
  'IN-JK': [
    'Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Sopore', 'Kathua', 'Udhampur',
    'Pulwama', 'Kupwara', 'Rajouri', 'Poonch', 'Doda', 'Kishtwar', 'Budgam',
    'Gulmarg', 'Pahalgam', 'Sonamarg', 'Patnitop', 'Vaishno Devi', 'Amarnath',
  ],
  
  // Ladakh
  'IN-LA': [
    'Leh', 'Kargil', 'Diskit', 'Nubra', 'Pangong', 'Tso Moriri', 'Zanskar',
    'Hemis', 'Thiksey', 'Lamayuru', 'Alchi',
  ],
  
  // Andaman and Nicobar Islands
  'IN-AN': [
    'Port Blair', 'Diglipur', 'Rangat', 'Mayabunder', 'Wandoor', 'Havelock Island',
    'Neil Island', 'Baratang', 'Car Nicobar', 'Campbell Bay',
  ],
  
  // ==================== OTHER COUNTRIES ====================
  
  // United States - Major Cities by State
  'US-CA': ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Sacramento', 'Oakland', 'Fresno', 'Long Beach', 'Bakersfield', 'Anaheim', 'Santa Ana', 'Riverside', 'Stockton', 'Irvine', 'Fremont', 'Palo Alto', 'Mountain View', 'Sunnyvale', 'Santa Clara', 'Berkeley'],
  'US-NY': ['New York City', 'Buffalo', 'Rochester', 'Albany', 'Syracuse', 'Yonkers', 'New Rochelle', 'White Plains', 'Schenectady', 'Utica', 'Manhattan', 'Brooklyn', 'Queens', 'Bronx', 'Staten Island'],
  'US-TX': ['Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth', 'El Paso', 'Arlington', 'Corpus Christi', 'Plano', 'Laredo', 'Lubbock', 'Irving', 'Garland', 'Frisco', 'McKinney'],
  'US-FL': ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'St. Petersburg', 'Hialeah', 'Tallahassee', 'Cape Coral', 'Pembroke Pines', 'Hollywood', 'Fort Myers', 'Gainesville', 'Clearwater'],
  'US-IL': ['Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Springfield', 'Elgin', 'Peoria', 'Champaign', 'Evanston', 'Schaumburg', 'Oak Park'],
  'US-WA': ['Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue', 'Kent', 'Everett', 'Renton', 'Redmond', 'Kirkland', 'Federal Way', 'Olympia'],
  'US-MA': ['Boston', 'Worcester', 'Springfield', 'Cambridge', 'Lowell', 'Brockton', 'New Bedford', 'Quincy', 'Lynn', 'Fall River', 'Somerville', 'Newton'],
  
  // United Kingdom
  'GB-ENG': ['London', 'Birmingham', 'Manchester', 'Leeds', 'Liverpool', 'Sheffield', 'Bristol', 'Newcastle', 'Nottingham', 'Leicester', 'Coventry', 'Bradford', 'Brighton', 'Reading', 'Oxford', 'Cambridge', 'Milton Keynes', 'Southampton', 'Portsmouth', 'York'],
  'GB-SCT': ['Edinburgh', 'Glasgow', 'Aberdeen', 'Dundee', 'Inverness', 'Perth', 'Stirling', 'Paisley', 'Falkirk', 'St Andrews'],
  'GB-WLS': ['Cardiff', 'Swansea', 'Newport', 'Wrexham', 'Barry', 'Neath', 'Pontypridd', 'Cwmbran', 'Llanelli', 'Bridgend'],
  'GB-NIR': ['Belfast', 'Derry', 'Lisburn', 'Newry', 'Bangor', 'Craigavon', 'Newtownabbey', 'Carrickfergus', 'Coleraine'],
  
  // UAE
  'AE-DU': ['Dubai', 'Dubai Marina', 'Downtown Dubai', 'Jumeirah', 'Deira', 'Bur Dubai', 'Business Bay', 'DIFC', 'Palm Jumeirah', 'JLT', 'Dubai Silicon Oasis', 'Dubai Internet City', 'Dubai Media City'],
  'AE-AZ': ['Abu Dhabi', 'Al Ain', 'Khalifa City', 'Yas Island', 'Saadiyat Island', 'Reem Island', 'Mussafah', 'Al Raha'],
  'AE-SH': ['Sharjah', 'Al Majaz', 'Al Nahda', 'Al Qasba', 'Al Khan', 'Industrial Area'],
  
  // Singapore
  'SG-SG': ['Singapore', 'Orchard', 'Marina Bay', 'Sentosa', 'Jurong', 'Changi', 'Tampines', 'Woodlands', 'Ang Mo Kio', 'Bishan', 'Clementi', 'Toa Payoh', 'Raffles Place', 'Clarke Quay', 'Little India', 'Chinatown'],
  
  // Australia
  'AU-NSW': ['Sydney', 'Newcastle', 'Wollongong', 'Central Coast', 'Maitland', 'Wagga Wagga', 'Albury', 'Port Macquarie', 'Tamworth', 'Orange', 'Parramatta', 'Bondi', 'Manly'],
  'AU-VIC': ['Melbourne', 'Geelong', 'Ballarat', 'Bendigo', 'Shepparton', 'Mildura', 'Warrnambool', 'Wodonga', 'Traralgon', 'Sunbury', 'St Kilda', 'Brighton', 'Richmond'],
  'AU-QLD': ['Brisbane', 'Gold Coast', 'Sunshine Coast', 'Townsville', 'Cairns', 'Toowoomba', 'Mackay', 'Rockhampton', 'Bundaberg', 'Surfers Paradise'],
  
  // Canada
  'CA-ON': ['Toronto', 'Ottawa', 'Mississauga', 'Brampton', 'Hamilton', 'London', 'Markham', 'Vaughan', 'Kitchener', 'Windsor', 'Richmond Hill', 'Oakville', 'Burlington', 'Scarborough', 'North York'],
  'CA-BC': ['Vancouver', 'Victoria', 'Surrey', 'Burnaby', 'Richmond', 'Coquitlam', 'Kelowna', 'Abbotsford', 'Nanaimo', 'Kamloops', 'Whistler', 'North Vancouver', 'West Vancouver'],
  'CA-QC': ['Montreal', 'Quebec City', 'Laval', 'Gatineau', 'Longueuil', 'Sherbrooke', 'Saguenay', 'Trois-Rivières', 'Terrebonne', 'Saint-Jean-sur-Richelieu'],
  'CA-AB': ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'St. Albert', 'Medicine Hat', 'Grande Prairie', 'Airdrie', 'Spruce Grove', 'Banff', 'Jasper', 'Canmore'],
};

/**
 * Get states for a country
 * @param {string} countryCode - ISO country code (e.g., 'IN', 'US')
 * @returns {Array} - Array of state objects with code and name
 */
export const getStatesForCountry = (countryCode) => {
  return states[countryCode] || [];
};

/**
 * Get cities for a country and state
 * @param {string} countryCode - ISO country code
 * @param {string} stateCode - State code
 * @returns {Array} - Array of city names
 */
export const getCitiesForState = (countryCode, stateCode) => {
  const key = `${countryCode}-${stateCode}`;
  return cities[key] || [];
};

/**
 * Get timezone for a country
 * @param {string} countryCode - ISO country code
 * @returns {string} - Timezone string
 */
export const getTimezoneForCountry = (countryCode) => {
  const country = countries.find(c => c.code === countryCode);
  return country?.timezone || 'UTC';
};

export default {
  countries,
  states,
  cities,
  getStatesForCountry,
  getCitiesForState,
  getTimezoneForCountry,
};
